import React from 'react';
import SEO from '../../components/SEO';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import IndustryHero from '../../components/industries/IndustryHero';
import IndustryContent from '../../components/industries/IndustryContent';
import IndustryCTA from '../../components/industries/IndustryCTA';

const Fintech = () => {
  const industryData = {
    title: 'Fintech',
    subtitle: 'Innovative financial technology solutions',
    description: 'Build the future of finance with secure, scalable, and user-friendly fintech applications. We create digital banking platforms, payment solutions, and financial management tools that meet the highest security and compliance standards.',
    challenges: [
      {
        title: 'Digital Banking Platforms',
        description: 'Create comprehensive digital banking experiences with account management, transactions, and personalized financial insights.'
      },
      {
        title: 'Payment Processing',
        description: 'Develop secure payment gateways and processing systems that handle transactions seamlessly across multiple channels.'
      },
      {
        title: 'Lending & Credit Solutions',
        description: 'Build automated lending platforms with credit scoring, risk assessment, and streamlined approval workflows.'
      },
      {
        title: 'Regulatory Compliance',
        description: 'Ensure compliance with financial regulations including KYC, AML, and data protection requirements across jurisdictions.'
      }
    ],
    services: [
      'Digital Banking and Neobank Development',
      'Payment Gateway Integration',
      'Peer-to-Peer Payment Applications',
      'Cryptocurrency and Blockchain Solutions',
      'Personal Finance Management Tools',
      'Regulatory Compliance and Security Implementation'
    ],
    technologies: ['React', 'Node.js', 'Python', 'PostgreSQL', 'MongoDB', 'AWS', 'Blockchain', 'Encryption']
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Fintech Development Services"
        description="Custom fintech solutions — payment platforms, banking apps, trading systems, and regulatory compliance tools built for financial institutions and startups."
        path="/industries/fintech"
      />
      <Header />
      <IndustryHero data={industryData} />
      <IndustryContent data={industryData} />
      <IndustryCTA industry="Fintech" />
      <Footer />
    </div>
  );
};

export default Fintech;
